<template>
  <div>
    <BOverlay
      :show="loadingData"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      class=" w-100"
      rounded="sm"
    >
      <b-table
        id="table"
        hover
        show-empty
        :items="listServices"
        :fields="fields"
        empty-text="Tidak ada data yang ditampilkan."
        responsive
      >
        <template #cell(shipping_name)="data">
          <div
            class="d-flex gap-10"
          >
            <div class="w-14 bg-[#FFECE9] px-[7px] py-[3px] rounded-pill">
              <img
                :src="data.item.image_logo"
                alt=""
              >
            </div>
            <div class="align-self-center">
              {{ data.value }}
            </div>
          </div>
        </template>
        <template #cell(is_regular)="data">
          <b-form-checkbox
            v-if="data.value === 1"
            :checked="data.value === 1"
            style="pointer-events: none;"
          />
          <b-form-checkbox
            v-else
            :checked="data.value === 1"
            disabled
            style="pointer-events: none;"
          />
        </template>
        <template #cell(is_cargo)="data">
          <b-form-checkbox
            v-if="data.value === 1"
            :checked="data.value === 1"
            style="pointer-events: none;"
          />
          <b-form-checkbox
            v-else
            :checked="data.value === 1"
            disabled
            style="pointer-events: none;"
          />
        </template>
        <template #cell(is_lite)="data">
          <b-form-checkbox
            v-if="data.value === 1"
            :checked="data.value === 1"
            style="pointer-events: none;"
          />
          <b-form-checkbox
            v-else
            :checked="data.value === 1"
            disabled
            style="pointer-events: none;"
          />
        </template>
        <template #cell(is_flat)="data">
          <div
            class="w-full"
            style="text-align: center;"
          >
            <label class="custom-radio">
              <input
                type="radio"
                :name="'radio-flat-group'"
                :value="data.item.shipping_name"
                :checked="selectedFlat === data.item.shipping_name"
                :disabled="data.item.is_flat === 0"
                @click="toggleRadio(data.item.shipping_name)"
              >
              <span class="checkmark" />
            </label>
          </div>
        </template>
      </b-table>
    </BOverlay>
    <div class="d-flex justify-end gap-10 pr-3 border-t-2 pt-2">
      <b-button
        class="w-40"
        :variant="defaultFlat === selectedFlat ? 'outline-secondary' : 'outline-primary'"
        :disabled="defaultFlat === selectedFlat"
        @click="selectedFlat = defaultFlat"
      >
        Reset
      </b-button>
      <b-button
        class="w-40"
        :variant="defaultFlat === selectedFlat ? 'secondary' : 'primary'"
        :disabled="defaultFlat === selectedFlat"
        @click="$bvModal.show('modal-pin')"
      >
        Simpan
      </b-button>
    </div>

    <ModalPIN
      id="modal-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Konfirmasi Perubahan?"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Batal"
      @on-confirm-button="verifiedPin"
    />
  </div>
</template>

<script>
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import configFieldsExpeditionServices from './config'

export default {
  components: { ModalPIN },
  data() {
    return {
      loadingData: false,
      fields: configFieldsExpeditionServices,
      listServices: [],
      defaultFlat: null,
      selectedFlat: null,
    }
  },
  mounted() {
    this.getListServices()
  },
  methods: {
    toggleRadio(val) {
      this.selectedFlat = this.selectedFlat === val ? null : val
    },
    getListServices() {
      this.loadingData = true
      const params = {
        source: 'komship',
      }
      const url = '/komship/api/v1/admin/shipment/configure/service'

      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listServices = data
          const defaultItem = this.listServices.find(item => item.flat_status === 1)
          if (defaultItem) {
            this.defaultFlat = defaultItem.shipping_name
            this.selectedFlat = defaultItem.shipping_name
          }
          this.loadingData = false
        })
        .catch(err => {
          this.loadingData = false
          this.$toast_error({ message: 'Tidak mendapatkan list ekspedisi' })
        })
    },
    verifiedPin() {
      const url = '/komship/api/v1/admin/shipment/configure/switch-flat'
      const formData = new FormData()
      formData.append('shipping', this.selectedFlat)

      this.$http_new.post(url, formData)
        .then(res => {
          this.defaultFlat = null
          this.selectedFlat = null
          this.$toast_success({ message: 'Perubahan servis ekspedisi berhasil disimpan' })
          this.getListServices()
        })
        .catch(err => {
          this.$toast_error({ message: 'Gagal melakukan perubahan servis ekspedisi' })
        })
    },
  },
}
</script>

<style scoped>
/* custom radio button */
.custom-radio {
  position: relative;
  display: inline-block;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
}

.custom-radio input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 1px solid #d8d6de;
  border-radius: 50%;
  background-color: #fff;
  display: inline-block;
  position: relative;
  transition: 0.2s;
}

input:checked + .checkmark {
  background-color: #F95031;
  border-color: #F95031;
}

.checkmark::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #F95031;
  display: none;
}

input:checked + .checkmark::after {
  display: block;
}

input:disabled + .checkmark {
  background-color: #e9ecef;
  cursor: not-allowed;
  border-color: #ccc;
}
/* end custom radio button */
</style>
